export default class ThemeConfig {
  constructor(themeObj) {
    this.themeObj = themeObj;
  }

  get showCasedPrefetchLimit() {
    return this.themeObj.vars.SHOWCASED_PREFETCH_LIMIT;
  }

  get collapsedTagFiltersFlag() {
    return this.themeObj.vars.COLLAPSE_TAG_FILTERS;
  }

  get components() {
    return this.themeObj.components;
  }

  get pages() {
    return this.themeObj.pages;
  }

  get pageOptions() {
    return this.themeObj.options.pages;
  }

  isDisabled(pageName) {
    if (this.pageOptions) {
      return !!this.pageOptions[pageName]?.disabled;
    } else {
      return false;
    }
  }
}
